import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ArrowUpRight({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass}
      width={width}
    >
      <path fill="currentColor" d="M488 128C501.3 128 512 138.7 512 152L512 392C512 405.3 501.3 416 488 416C474.7 416 464 405.3 464 392L464 209.9L169 504.9C159.6 514.3 144.4 514.3 135.1 504.9C125.8 495.5 125.7 480.4 135 471L430 176L247.9 176C234.6 176 223.9 165.3 223.9 152C223.9 138.7 234.6 128 247.9 128L487.9 128z" />
    </svg>
  );
}
